const STEPS = [
  {
    number: "01",
    title: "Find the Idea",
    description: "Identify a question, calculation, decision or challenge your prospects regularly face.",
  },
  {
    number: "02",
    title: "Build the Experience",
    description: "Turn your expertise into a polished calculator, assessment or custom application.",
  },
  {
    number: "03",
    title: "Generate Engagement",
    description: "Launch and promote the experience across your marketing and sales channels.",
  },
  {
    number: "04",
    title: "Start Better Conversations",
    description: "Capture more than contact information. Give your sales team context about what each prospect actually cares about.",
  },
];

type Step = { number: string; title: string; description: string };

interface ProcessSectionProps {
  eyebrow?: string;
  title?: string;
  lead?: string;
  steps?: Step[];
}

export function ProcessSection({
  eyebrow = "From Expertise to Experience",
  title = "You already know what your prospects care about.",
  lead = "The opportunity is turning that knowledge into something they can interact with.",
  steps = STEPS,
}: ProcessSectionProps = {}) {
  return (
    <section id="process" className="border-t border-border/50 bg-[#080E1E]/95 px-5 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 grid gap-5 sm:mb-10 sm:gap-6 md:mb-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:items-start">
          <div>
            <p className="text-xs font-semibold tracking-[0.22em] text-primary uppercase mb-4">
              {eyebrow}
            </p>
            <h2 className="text-3xl sm:text-4xl font-semibold leading-tight">
              {title}
            </h2>
          </div>
          <p className="text-muted-foreground leading-relaxed lg:text-lg lg:pt-11">
            {lead}
          </p>
        </div>

        <div className="grid gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-4 lg:gap-10">
          {steps.map((step) => (
            <div key={step.number} className="group">
              <span className="block text-3xl font-semibold text-primary/30 mb-3 group-hover:text-primary/50 transition-colors">
                {step.number}
              </span>
              <h3 className="text-lg font-semibold mb-3 pb-3 border-b border-border/60">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
